export default __webpack_public_path__ + "static/media/marker-gray-sky-orange.1d93c4cd.png";